import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { DocumentCategoryService } from '../document-category.service';
import { NotificationService } from 'src/app/services/notification.service';
import { finalize, map, Observable } from 'rxjs';
import { IDocumentCategory, IEditDocumentCategoryPayload, IFormDocumentCategory } from '../document-category.interface';
import { Generic } from 'src/app/interfaces/generic.interface';

@Component({
    selector: 'app-edit-document-category',
    templateUrl: './edit-document-category.component.html',
    styleUrls: ['./edit-document-category.component.scss']
})
export class EditDocumentCategoryComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    defaultParameter: { name: string; id: string } = {
        name: '--Alegeți--',
        id: '-1',
    };

    documentCategories$!: Observable<Generic[]>;

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
        slug: new FormControl(this.data.slug, [Validators.required]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: IDocumentCategory,
        private dialogRef: MatDialogRef<EditDocumentCategoryComponent>,
        private documentTypeService: DocumentCategoryService,
        private documentCategoryService: DocumentCategoryService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, slug } = this.form.value as IFormDocumentCategory;
        const payload: IEditDocumentCategoryPayload = {
            id: this.data.id,
            name,
            slug
        };

        this.documentTypeService
            .updateDocumentCategory(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
